<template>
  <div id="event-information">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="event_information"></footer-app>
      <!-- event information -->
      <section :class="{'fade-base': true, 'fade': pageFade}">
        <div class="l-event">
          <div class="l-event__head bg-transparent l-main--bg-border pt-64">
            <div class="l-list-menu">
              <div class="l-list-menu__tab">
                     <!-- //// クーポン //////////////////////////////////// -->
                      <div class="c-list-store__swiper">
                        <div class="js-store-swiper swiper-container">
                        <div class="swiper-wrapper store-swiper " style="overflow: visible">
                          <div class="swiper-slide ml-17 " v-on:click="listFiltering($event)">
                            <div class="img active">
                              <img loading="lazy" src="/assets/images/demo/store-8.svg" alt="" />
                            </div>
                            <div class="name">すべて</div>
                          </div>
                          <div class="swiper-slide" v-for="(provider, index) in providers" :key="index">
                            <div class="name-provider" v-on:click="listFiltering($event, provider)">
                              <div class="img">
                                <img loading="lazy" v-bind:src="provider.image ? getImgSrc(provider.image[0]) : '' " alt="" />
                              </div>
                              <div class="name">{{ provider.shopName }}</div>
                            </div>
                          </div>
                        </div>
                        </div>

                        <div class="c-coupon_category__area">
                          <div class="c-coupon_category__selected" v-on:click="toggleSelectCategoryList()">
                            {{selectedCategoryName}}
                          </div>
                          <div v-show="isCouponCategory" class="c-coupon_category__list--wrap">
                            <ul class="c-coupon_category__list">
                              <li v-on:click="selectCategory(null)">全て</li>
                              <li v-for="(couponCategory, index) in couponCategorysList" :key="index" v-on:click="selectCategory(couponCategory.id,couponCategory.title)">
                                {{ couponCategory.title }}
                              </li>

                            </ul>
                          </div>
                          
                        </div>

                        <div class="l-favorite pb-50 mt-10">

                          <div class="l-list-coupon pt-0 pb-12 l-list-coupon-event" v-if="couponsList.length == 0">
                            ただいま提供中のクーポンはありません
                          </div>

                          <ul class="l-list-coupon__column c-list-deal">
                            <li v-for="(coupon, index) in couponsList" :key="index">
                              <div class="l-list-coupon-evnent" >
                                <div class="c-coupon c-coupon-have-name">
                                  <div v-on:click="getDataModal(coupon)" class="c-news__shop">
                                    <div v-if="coupon.provider && coupon.provider.id" class="c-news__shop--img">
                                      <img v-lazy="coupon.provider.image && getImgSrc(coupon.provider.image[0])" alt="" />
                                    </div>
                                    <div v-else class="c-news__shop--img"><img loading="lazy" src="/assets/images/aeontown-logo.png" /></div>
                                    <div v-if="coupon.provider && coupon.provider.id" class="c-news__shop--name">{{ coupon.provider.shopName }}</div>
                                    <div v-else class="c-news__shop--name">{{coupon.provider.name}}</div>
                                  </div>
                                  <div v-if="coupon.image" class="c-coupon__top image-fit js-keep-ratio" data-ratio="0.75" v-on:click="getDataModal(coupon)">
                                    <div v-if="coupon.label == '3'" class="c-coupon__top__label label__any">何回でも</div>
                                    <div v-else-if="coupon.label == '2'" class="c-coupon__top__label label__more">複数回</div>
                                    <div v-else-if="coupon.label == '1'" class="c-coupon__top__label">一回限り</div>
                                    <div v-else ></div>
                                    <img v-lazy="getImgSrc(coupon.image[0])" alt=""/>
                                  </div>
                                  <div v-else class="c-coupon__top image-fit js-keep-ratio" data-ratio="0.75" v-on:click="getDataModal(coupon)">
                                    <div v-if="coupon.label == '3'" class="c-coupon__top__label label__any">何回でも</div>
                                    <div v-else-if="coupon.label == '2'" class="c-coupon__top__label label__more">複数回</div>
                                    <div v-else-if="coupon.label == '1'" class="c-coupon__top__label">一回限り</div>
                                    <div v-else ></div>
                                    <img loading="lazy" src="/assets/images/aeontown-noimg.png" alt=""/>
                                  </div>
                                  <div class="l-list-coupon__column__info">
                                    <div class="l-list-coupon__column__info--guidewrap">
                                      <div class="l-list-coupon__column__info--guide line-clamp-hack">
                                        <div v-html="removehtml(coupon.guide)"></div>
                                      </div>
                                    </div>
                                    
                                    <div class="l-list-coupon__column__info--time">
                                      <div v-on:click="getDataModal(coupon)" class="c-tag c-tag--violet">利用期限</div>
                                      <div v-if="!coupon.unlimited" v-on:click="getDataModal(coupon)" class="date">
                                        {{ coupon.availableFrom && formatDateForOrder(coupon.availableFrom) }}〜{{ coupon.availableTo && formatDateForOrder(coupon.availableTo) }}
                                      </div>
                                      <div v-else v-on:click="getDataModal(coupon)" class="date">無期限</div>


                                     </div>
                                     
                                     <div class="l-list-coupon__column__info--button">
                                       <div class="heart">
                                        <div v-if="favoriteCouponExists(coupon)" class="c-heart is-active" v-on:click="deleteFavorite(coupon, COUPON_COLLECTION_KEY, coupon.provider)">
                                           <svg width="20" height="18" class="c-heart__active"><use xlink:href="#ic-icon-heart-active" /></svg>
                                        </div>
                                        <div v-else class="c-heart" v-on:click="addFavorite(coupon, COUPON_COLLECTION_KEY, coupon.provider)">
                                          <svg width="20" height="18" class="c-heart__unactive"><use xlink:href="#ic-icon-heart" /></svg>
                                        </div>
                                      </div>
                                      
                                      <div class="button">
                                        <div v-if="coupon.mogiri" v-on:click="getDataModal(coupon)" class="c-btn c-btn--coupon">詳細をみる</div>
                                        <div v-else v-on:click="getDataModal(coupon)" class="c-btn c-btn--coupon">このクーポンを<br>利用する</div>
                                      </div>
                                    </div>
                                    
                                  </div>
                                  <div v-if="coupon.overline || coupon.userCountRemaining == 0" class="over-coupon">
                                    <div style="display: grid; justify-content: center;">
                                      <span>
                                        <span v-if="coupon.userCountRemaining == 0" class="over-coupon__content">使用済</span>
                                        <span v-else-if="coupon.overline" :class="coupon.useCoupnData && coupon.useCoupnData.length > 0 ? 'over-coupon__content' : 'over-coupon__text'">終了しました</span>
                                      </span>
                                      <p v-if="coupon.useCoupnData && coupon.useCoupnData.length > 0" class="over-coupon__text" @click="showCouponUsed(coupon)">
                                        使用履歴 >
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                          <div ref="observe_element"></div>
                        </div>
                      </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div id="coupon-popup" class="l-shop l-shop--detail l-shop-overlay fixed" v-if="showModal" style=" z-index: 201;">
            <div class="l-list-coupon l-list-coupon--detail p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
              <div class="l-main__head--control l-main__head--control--close" @click="closeCouponModal">
                <img src="/assets/images/icon/icon-close-black.svg" alt="" />
              </div>
              <div class="c-coupon c-coupon-have-name">
                <template v-if="showCouponDialog">
                  <div class="c-coupon__top image-fit js-keep-ratio" data-ratio="0.75">
                    <div v-if="couponDetail.label == '3'" class="c-coupon__top__label label__any">何回でも</div>
                    <div v-else-if="couponDetail.label == '2'" class="c-coupon__top__label label__more">複数回</div>
                    <div v-else-if="couponDetail.label == '1'" class="c-coupon__top__label">一回限り</div>
                    <div v-else ></div>
                    <img :src="getImgSrc(couponDetail.image && couponDetail.image[0])" alt="" />
                  </div>
                  <div class="c-coupon__bot">
                    <div class="c-coupon__time">
                      <div class="c-tag c-tag--violet c-tag--xl">利用期限</div>
                      <div 
                        v-if="favoriteCouponExists(couponDetail)" 
                        class="c-heart c-heart--xl is-active" 
                        v-on:click="deleteFavorite(couponDetail, COUPON_COLLECTION_KEY, couponDetail.provider)"
                      >
                      <svg width="30" height="27" class="c-heart__active">
                        <use xlink:href="#ic-icon-heart-active" />
                      </svg>
                    </div>
                    <div v-else class="c-heart c-heart--xl" v-on:click="addFavorite(couponDetail, COUPON_COLLECTION_KEY, couponDetail.provider)"> 
                       <svg width="30" height="27" class="c-heart__unactive">
                         <use xlink:href="#ic-icon-heart" />
                        </svg>
                    </div>
                    <span v-if="!couponDetail.unlimited" class="mt-8">{{  couponDetail.availableFrom && formatDateForOrder(couponDetail.availableFrom) }}〜{{ couponDetail.availableTo && formatDateForOrder(couponDetail.availableTo) }}</span>
                    <span v-else class="mt-8" style="width: 100%">無期限</span>
                    <div v-if="!couponDetail.mogiri" class="mt-8 font-size-14 color-4">
                      ※利用の際は従業員へお見せ下さい
                    </div>
                  </div>
                  <div class="c-coupon__content">
                    <div class="font-size-14 color-4" v-if="couponDetail.mogiri" >
                      <div v-if="couponDetail.usableTime && (couponDetail.usableTime.from || couponDetail.usableTime.to)">ご使用可能時間：{{couponDetail.usableTime.from}}～{{couponDetail.usableTime.to}}</div>
                    </div>
                    <h1 class="c-coupon__content--not-bold">
                      <div v-html="autolink(couponDetail.guide)"></div>
                    </h1>
                    <div v-html="autolink(couponDetail.notice)"></div>
                    <div v-if="couponDetail.couponCode">
                      <div class="c-btn c-btn--red mt-16 box-center" @click.prevent="applyMobileOrderCoupon(couponDetail.couponCode)">
                        モバイルオーダーで使用する
                      </div>
                    </div>
                  </div>
                  <div v-if="couponDetail.mogiri && !isUserLoggedIn()" class="pl-16 pr-16">
                    <p v-if="!isUserLoggedIn()" class="color-4 m-0"><small>こちらのサービスを利用するには、ログインが必要です。</small></p>
                  </div>
                  <div v-if="couponDetail.mogiri" >
                    <router-link v-if="!isUserLoggedIn()" to="/account/profile" class="c-btn c-btn--red mt-8 box-center">ログインはこちら</router-link>
                    <div v-else class="c-btn mt-16 box-center" 
                    :class="[couponDetail.unlimited || isDateNow(couponDetail.availableFrom,couponDetail.availableTo) ? 'c-btn--red' : 'c-btn--disabled']"
                    @click.prevent="showUseMogiriCoupon()">
                        このクーポンを利用する 
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="showContinueDialog">
                <div class="c-coupon__bot" style="height:auto !important;">
                  <h4 class="text-center m-0" v-if="useCoupnData && useCoupnData.length >= couponDetail.usableNumber && useCoupnData.length > 0">このクーポンは使用済です</h4>
                  <h4 class="text-center m-0" v-else>クーポンを使用しますか？</h4>
                  <div class="pt-12 pl-16 pr-16 color-4" v-if="!useCoupnData || useCoupnData.length < couponDetail.usableNumber || useCoupnData.length <= 0"><b>ご使用後はキャンセルできませんのでご注意ください</b></div>
                  <div class="p-16 font-size-14"> 
                    <div v-if="couponDetail.usableTime && (couponDetail.usableTime.from || couponDetail.usableTime.to)">ご使用可能時間：{{couponDetail.usableTime.from}}～{{couponDetail.usableTime.to}}</div>
                    <div>現在ご使用回数：{{useCoupnData ? useCoupnData.length : "0"}}回 &nbsp;<span v-if="useCoupnData && useCoupnData.length < couponDetail.usableNumber && useCoupnData.length > 0"  style="color: #2B2B2B; text-decoration: underline;" @click.prevent="showUsageHistory()" class="color-1">＞使用履歴</span>
                    </div>
                    <div>残りご使用回数：{{userCountRemaining(couponDetail.usableNumber , (useCoupnData ? useCoupnData.length : 0))}}回</div>
                    <div>クーポンID：{{couponDetail.aiCouponCode}}</div>
                  </div>
                  <div v-if="useCoupnData && useCoupnData.length >= couponDetail.usableNumber && useCoupnData.length > 0">
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="showUsageHistory()">
                        使用履歴を見る
                    </div>
                    <div class="c-btn mt-8 c-btn--coupon box-center" @click.prevent="cancelUseCoupon()">
                        閉じる
                    </div>
                    <!-- 
                    <div class="mt-24 p-16 font-size-14">誤って使用済みにしてしまった方は<span style="color: #2B2B2B; text-decoration: underline;" @click.prevent="showCancellationCoupon(couponDetail)" class="color-1">こちら</span>へ</div>
                    -->
                  </div>
                  <div v-else>
                    <div v-if="couponDetail.tenantSelectedType" class="c-modal__content bg-white pt-0">
                      <p class="c-modal__subTitle mt-0">ショップの選択</p>
                      <div class="mb-8">
                        <select class="c-select" name="" id="" v-model="selectCategoryType" @change="changeSelectCategoryType">
                          <template v-if="selectTenantCategoryList.size > 1"><option value="0">すべて</option>
                          </template>
                          <option v-for="[index, name] of [...selectTenantCategoryList]" :key="index"  :value="index">{{name}}</option>
                        </select>
                      </div>
                      <div class=" mb-8">
                        <select class="c-select" name="" id="" v-model="selectTenantId">
                          <option value="">選択してください</option>
                          <option v-for="(name, index) in selectTenantList" :key="index"  :value="index">{{name}}</option>
                        </select>
                      </div>
                      <div v-if="selectTenantErrMsg != ''" class="font-size-14 color-4"><b>{{selectTenantErrMsg}}</b></div>
                    </div>
                    
                    <div class="c-btn c-btn--red box-center" v-bind:class="{ disabled: isUseCouponEnabled }" @click.prevent="applyUsedCoupon()">
                        使用する
                    </div>
                    <div class="p-16 font-size-12 color-4"><b>※従業員が確認してから押してください</b></div>
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="cancelUseCoupon()">
                        使用しない
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="showUsedCouponDialog">
                <div class="c-coupon__bot" style="height:auto !important;">
                  <h4 class="text-center m-0">このクーポンの使用取消を行いますか？</h4>
                  <div class="p-16 font-size-14 color-4">
                    <p>クーポン発行店舗の従業員の方に認証コードを入力いただいてください<br>クーポンID：{{couponDetail.aiCouponCode}}</p>
                    <input class="c-otp c-input-zip" type="text" maxlength="4" v-model="cancelCode" placeholder="４桁の認証コードを入力してください" />
                  </div>
                  <div>
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="applyCancellationCoupon()">
                        使用取消を行う
                    </div>
                    <div class="p-16 font-size-14"><b>※使用取消を行うボタンは認証コードを入力した従業員の方が押して下さい</b></div>
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="cancelCancellationCoupon()">
                        キャンセル
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="showUsageHistoryDialog">
                <div class="c-coupon__bot" style="height:auto !important;">
                  <h4 class="text-center m-0">このクーポンの使用履歴</h4>
                  <div class="p-16 font-size-14"> 
                    <div v-if="couponDetail.usableTime && (couponDetail.usableTime.from || couponDetail.usableTime.to)">ご使用可能時間：{{couponDetail.usableTime.from}}～{{couponDetail.usableTime.to}}</div>
                    <div>現在ご使用回数：{{useCoupnData ? useCoupnData.length : "0"}}回</div>
                    <div>残りご使用回数：{{userCountRemaining(couponDetail.usableNumber , (useCoupnData ? useCoupnData.length : 0))}}回</div>
                    <div>クーポンID：{{couponDetail.aiCouponCode}}</div>
                  </div>
                   <div class="p-16 pt-0 c-usageHistory-coupon">
                    <ol>
                      <li v-for="(data, index) in useCoupnData" :key="index">{{formatDateTimeCoupon(data.useAt) }} {{ data.shopName }}</li>
                    </ol>
                   </div>
                  <div>
                    <div class="c-btn c-btn--coupon box-center" @click.prevent="closeCouponModal()">
                        閉じる
                    </div>
                  </div>
                </div>
              </template>
              </div>
            </div>
      </div>
      
      <div id="error-popup" class="l-shop l-shop--detail l-shop-overlay fixed" v-if="errorModal" style=" z-index: 201;">
        <div class="p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
          <div class="c-modal__dialog--center c-modal__content">
            <div>
              <h3 class="c-modal__title ">上限エラー</h3>
              <div class="text-center "><img src="/assets/images/icon/icon-warning.svg" width="90px"></div>
              <p class="color-2"><b>{{errorLimitMessage}}</b></p>
              <div class="c-btn mt-16 box-center" @click.prevent="closeErrorModal()">
                  閉じる
              </div>
            </div>
          </div>
        </div>
      </div>  
      <div id="usage-limit-popup" v-if="showUsageLimitDialog" class="l-shop l-shop--detail l-shop-overlay fixed" style=" z-index: 201;">
        <div class="l-list-coupon l-list-coupon--detail p-0 fixed" style="width: calc(100% - 30px);max-height: calc(100vh - 60px);">
          <div class="l-main__head--control l-main__head--control--close" @click="showUsageLimitDialog = false">
            <img src="/assets/images/icon/icon-close-black.svg" alt="" />
          </div>
          <div class="c-coupon__bot" style="height:auto !important; width: 100%;">
            <h4 class="text-center m-0">このクーポンの使用履歴</h4>
            <div class="p-16 font-size-14">
              <div v-if="couponDetail.usableTime && (couponDetail.usableTime.from || couponDetail.usableTime.to)">
                ご使用可能時間：{{couponDetail.usableTime.from}}～{{couponDetail.usableTime.to}}
              </div>
              <div>
                ご使用回数：{{couponDetail.useCoupnData ? couponDetail.useCoupnData.length : "0"}}回
              </div>
              <div>クーポンID：{{couponDetail.aiCouponCode}}</div>
            </div>
            <div class="p-16 pt-0 c-usageHistory-coupon">
              <ol>
                <li v-for="(data, index) in couponDetail.useCoupnData" :key="index">{{formatDateTimeCoupon(data.useAt) }} {{ data.shopName }}</li>
              </ol>
            </div>
            <div>
              <div class="c-btn c-btn--coupon box-center" @click.prevent="showUsageLimitDialog = false">閉じる</div>
            </div>
          </div>
        </div>
      </div>  

      <loader :loading="loading" />
      <!-- modal show congestion degree in header -->
      <modal_congestion_situation :counter-blocks=counterBlocks></modal_congestion_situation>
      <!-- modal show required login -->
      <modal_login_required></modal_login_required>
      <alert :message="alert_msg" 
      :show="alert_show" 
      :closeModal="closeModal" 
      :confirm_show="confirm_show" 
      :confirm_message="confirm_msg" 
      :confirm_callback="confirm_callback" 
      :confirm_hide_cancel="confirm_hide_cancel"
      :label_cancel="confirm_label_cancel"
      :label_ok="confirm_label_ok"
      :set_cover="set_cover"
      ></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import ModalCongestionSituation from "../components/ModalCongestionSituation.vue";
import ModalLoginRequired from "../components/ModalLoginRequired.vue";
import Swiper from "swiper";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { 
  getUser,
  getListShopProviders,
  getLocalListCoupon,
  getServerListCoupon, 
  getCouponDetail,
  getCouponUseHistorys,
  getLocalListCouponCategory,
  getListCouponCategory,
  getShop,
  getLottery
} from "../store/firestore.js";
import { DB, COUPON_COLLECTION_KEY } from "../config/const.js";
const $ = window.$;
import dayjs from "dayjs";
import PopAlert from "../components/PopAlert.vue";
import firebase from "../common/firebaseProject";
import loader from "../components/parts/loader.vue"

export default Vue.extend({
  name: "Coupon",
  components: {
    'footer-app': Footer,
    'header-app': Header,
    'menu-app': Menu,
    'modal_congestion_situation': ModalCongestionSituation,
    'modal_login_required': ModalLoginRequired,
    'alert': Alert,
    "loader":loader,
    PopAlert
  },
  mixins: [Tenant],
  data () {
    return {
      user: undefined,
      attrs: [
        {
          key: 'today',
          highlight: true,
          dates: new Date(),
        }
      ],
      providersAll: [],
      providers: [],
      currentProvider: null,
      observer: null,
      couponSize: 20,
      couponsAll: [],
      couponsList: [],
      couponsListTemp: [],
      couponCategorysList: [],
      couponCategorysListTemp: [],
      showModal: false,
      couponDetail: {},
      COUPON_COLLECTION_KEY: COUPON_COLLECTION_KEY,
      store_swiper: null,
      loading: false,
      showCouponDialog:true,
      showContinueDialog: false,
      showUsedCouponDialog: false,
      useCoupnData:null,
      isUseCouponEnabled:false,
      showUsageLimitDialog:false,
      isUseCouponProcessing:false,
      cancelCode:null,
      couponCategoryList:[],
      isCouponCategory:false,
      selectedCategoryName:"全て",
      set_cover:false,
      selectCategoryType:"0",
      selectTenantId:"",
      errorModal:false,
      errorLimitMessage:"このクーポンは使用上限に達したためご使用できません。",
      showUsageHistoryDialog:false,
      /*
      allTenantCategoryList: {
        5: 'グルメ・フード',
        2: 'ファッション',
        4: 'サービス',
        6: 'アミューズメント',
        3: 'グッズ',
        1: 'スーパーマーケット総合スーパー',
      },
      */
     allTenantCategoryList: new Map([
        ['5', 'グルメ・フード'],
        ['2', 'ファッション'],
        ['4', 'サービス'],
        ['6', 'アミューズメント'],
        ['3', 'グッズ'],
        ['1', 'スーパーマーケット総合スーパー'],
      ]),
      selectTenantCategoryList: new Map(),
      allTenantList: {},
      selectTenantList:{},
      selectTenantErrMsg: "",
    }
  },
  async created () {

    // pushからのshopId付きの起動
    let shopId = Common.getUrlParam('shopId');
    if (shopId && shopId != this.$store.state.shopId) {
      const shop = await getShop(shopId);
      this.set_cover = true;
      const res =  await this.confirm(`${shop.name}\n\nこの店舗に表示を切り替える`, false, { ok_label: 'はい', cancel_label: 'いいえ' });
      if (res) {
        await this.$store.dispatch('setShopId', shopId);
        location.reload()
      } else {
        this.$router.push('/top');
      }
    }

    this.providersAll = await getListShopProviders(this.$store.state.shopId);

    this.user = await getUser(this.$store.state.userId);
    await this.getLocalDataCoupons()
    this.getLocalDataCouponCategorys();
    await this.getProviders();

    $('html').scrollTop(this.$store.state.couponScrollPosition)
    //this.$store.dispatch('setCouponScrollPosition', 0);

    setTimeout(async () => {
      await this.getDataCoupons();
      this.getDataCouponCategorys();
      await this.getProviders();
    },100);
  },

  mounted() {
    const swiper_store = new Swiper('.js-store-swiper', {
      direction: 'horizontal',
      spaceBetween: 16,
      slidesPerView: 'auto',
      scrollbar: {
        el: '.swiper-scrollbar'
      },
      touchMoveStopPropagation: true,
      observer: true
    })
    this.store_swiper = swiper_store;

    Common.initDom();

    this.observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry && entry.isIntersecting) {
          this.addCoupon();
        }
      });
    const observe_element = this.$refs.observe_element;
    this.observer.observe(observe_element);
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async showCouponUsed(coupon){
      await this.getDataModal(coupon, false);
      this.couponDetail = coupon;
      this.showUsageLimitDialog = true;
    },
    async getProviders() {
      this.providers = []
      let tmp = {}
      this.couponsAll.filter(c => c.tenantId).map(c => {
        tmp[c.provider.id] = c.provider;
      })
      this.providers = Object.values(tmp);
    },
    async getUseCoupnData(coupon) {
      if (!coupon?.mogiri) return coupon;
      const userId = this.$store.state.userId;
      const useHistorys = await getCouponUseHistorys(userId, coupon.id, coupon.lotteryId, coupon.lotteryEntryId, coupon.qreResultId);
      const useCoupnData = useHistorys.sort((a, b) => {
        return new Date(a.useAt) - new Date(b.useAt);
      }).map(useData => {
        useData.shopName = "";
        if (useData.tenantId) {
          const provider = this.providersAll.find(item => item.id == useData.tenantId);
          if (provider) {
            useData.shopName = provider.shopName;
          }
        }
        return useData;
      });
      coupon.userCountRemaining = this.userCountRemaining(coupon.usableNumber , (useCoupnData ? useCoupnData.length : 0));
      coupon.useCoupnData = useCoupnData;
      return coupon;
    },

    async getLocalDataCoupons() {
      const temp = await getLocalListCoupon()
      const data = [];
      const overlinePromises = temp.map(async coupon => {
        const overline = await this.overLine(coupon.mogiri, coupon.maximumNumber, coupon.totalUseCount, coupon.id, coupon.lotteryId, coupon.lotteryEntryId, coupon.qreResultId);
        coupon.overline = overline || (coupon.totalUseCount >= coupon.maximumNumber && coupon.maximumNumber && coupon.totalUseCount);
        return this.getUseCoupnData(coupon);
      });
      const couponsWithOverline = await Promise.all(overlinePromises);
      data.push(...couponsWithOverline);
      this.couponsAll = data;
      /*
      this.couponsAll = await temp.map(async coupon => {
         const overline = await this.overLine(coupon.mogiri,coupon.maximumNumber, coupon.totalUseCount,coupon.id,coupon.lotteryId,coupon.qreResultId)
         coupon.overline = overline;
        return coupon;
      })
      */


      this.couponsListTemp = this.couponsAll;
      this.couponsList = this.couponsListTemp.slice(0, this.couponSize);

    },
    async getDataCoupons() {
      const userId = this.$store.state.userId;
      const temp = await getServerListCoupon(userId)
      const data = [];
      const overlinePromises = temp.map(async coupon => {
        const overline = await this.overLine(coupon.mogiri, coupon.maximumNumber, coupon.totalUseCount, coupon.id, coupon.lotteryId, coupon.lotteryEntryId, coupon.qreResultId);
        coupon.overline = overline || (coupon.totalUseCount >= coupon.maximumNumber && coupon.maximumNumber && coupon.totalUseCount);
        return this.getUseCoupnData(coupon);
      });
      const couponsWithOverline = await Promise.all(overlinePromises);
      data.push(...couponsWithOverline);
      this.couponsAll = data;
      /*
      this.couponsAll = await temp.map(async coupon => {
         const overline = await this.overLine(coupon.mogiri,coupon.maximumNumber, coupon.totalUseCount,coupon.id,coupon.lotteryId,coupon.qreResultId)
         coupon.overline = overline;
        return coupon;
      })
      */
 


      this.couponsListTemp = this.couponsAll;
      this.couponsList = this.couponsListTemp.slice(0, this.couponSize);
    },

    async getLocalDataCouponCategorys() {
      this.couponCategorysList = await getLocalListCouponCategory()
      this.couponCategorysListTemp = this.couponCategorysList;
      console.log(this.couponCategorysList);
      this.categoryListFiltering();

      if (this.$route.query.category) {
        this.couponCategorysList.map((couponCategory)=> {
          if (couponCategory.id == this.$route.query.category) {
            this.selectCategory(couponCategory.id,couponCategory.title)
          }
        })
      }
    },
    async getDataCouponCategorys() {
      this.couponCategorysList = await getListCouponCategory()
      this.couponCategorysListTemp = this.couponCategorysList;

      console.log(this.couponCategorysList);
      this.categoryListFiltering();

      if (this.$route.query.category) {
        this.couponCategorysList.map((couponCategory)=> {
          if (couponCategory.id == this.$route.query.category) {
            this.selectCategory(couponCategory.id,couponCategory.title)
          }
        })
      }
    },

    async getDataModal(couponData, isShow = true) {
      const id = couponData.id;
      const lotteryId = couponData.lotteryId;
      const lotteryEntryId = couponData.lotteryEntryId;
      const qreResultId = couponData.qreResultId;
      this.couponDetail = await getCouponDetail(id)
      if (lotteryId) {
        this.couponDetail.lotteryId = lotteryId;
      }
      if (lotteryEntryId) {
        this.couponDetail.lotteryEntryId = lotteryEntryId;
      }
      if (qreResultId) {
        this.couponDetail.qreResultId = qreResultId;
      }
      //this.$store.dispatch('setCouponScrollPosition', $('html').scrollTop());

      if (this.couponDetail.link && 0 < this.couponDetail.link.length) {
        Common.messageHandlers('show_browser', { url: this.couponDetail.link });
        return
      }

      //もぎりの場合ユーザーデータを取得し使用状況を確認する
      if (this.couponDetail.mogiri) {
        //ユーザー情報取得
        const userId = this.$store.state.userId;
        //クーポン使用歴確認する
        //今見ているクーポンIDが必要
        //使用可能な時間帯かどうか
        //getCouponUseHistorys = async (userId,this.couponDetail.couponId)
        const useHistorys = await getCouponUseHistorys(userId,this.couponDetail.id,this.couponDetail.lotteryId,this.couponDetail.lotteryEntryId,this.couponDetail.qreResultId);

        this.useCoupnData = useHistorys.sort((a, b) => {
          return new Date(a.useAt) - new Date(b.useAt);
        }).map(useData => {
          useData.shopName = "";
          if (useData.tenantId) {
            const provider = this.providersAll.find(item => item.id == useData.tenantId);
            if (provider) {
              useData.shopName = provider.shopName;
            }
          }
          return useData;
        });

        //使用日ごとに並び替え
        this.useCoupnData.sort((a,b) => {
          if (a.useAt > b.useAt) {
            return 1;
          } else {
            return -1;
          }
        })

        //使用可能な時間帯かどうか
        if (this.couponDetail.usableTime) {
          const now = dayjs();
          const stateTime = this.couponDetail.usableTime.from ? this.couponDetail.usableTime.from.split(':'): null;
          const endTime =  this.couponDetail.usableTime.to ? this.couponDetail.usableTime.to.split(':'): null;
          const nowHour = now.hour();
          const nowMinute = now.minute();
        
          if (stateTime && stateTime.length > 0) {
            if(nowHour < Number(stateTime[0]) ) {
              //非活性にする
              this.isUseCouponEnabled = true;
              if (nowHour == Number(stateTime[0]) && nowMinute > Number(stateTime[1])) {
                this.isUseCouponEnabled = false;
              }
            }
          }
          if (endTime &&endTime.length > 0) {
            if(nowHour > Number(endTime[0]) ) {
              //非活性にする
              this.isUseCouponEnabled = true;
              if ((endTime  == Number(endTime[1])) && nowMinute < Number(endTime[1])) {
                this.isUseCouponEnabled = false;
              }
            }
          }
        }
        if (this.couponDetail.tenantSelectedType) {
            // 店舗別設定
            this.selectCategoryType = "0";
            this.selectTenantId = "";
            this.selectTenantErrMsg = "";
            this.selectTenantCategoryList = new Map();
            this.allTenantList = {};
            this.selectTenantList = {};
            let temp = [];
            for (const tenantSelectedData of this.couponDetail.tenantSelectedDatas) {
              const provider = this.providersAll.find(item => item.id == tenantSelectedData.tenantId);
              if (provider) {
                temp.push(provider.shopCategoryType);
              }
            }
            // ソート
            /*
            const keys = Object.keys(temp);
            //keys.sort();
            for (let key of keys) {
              this.selectTenantCategoryList[key] = temp[key];
            }*/
            for (let [key, value] of this.allTenantCategoryList) {
              if (temp.includes(key)) {
                this.selectTenantCategoryList.set(key, this.allTenantCategoryList.get(key));
              }
            }

            if(this.selectTenantCategoryList.size == 1) {
              for (let [key, value] of this.selectTenantCategoryList) {
                this.selectCategoryType = key;
              }
            } 

            this.changeSelectCategoryType();
          }

        //if(this.couponDetail.usableTime.from > now || this.couponDetail.usableTime.to < now) {}
      }
      this.couponDetail.guide = Common.addExtLink(this.couponDetail.guide);
      this.couponDetail.notice = Common.addExtLink(this.couponDetail.notice);

      // Firebase analytics 
      // { tenantId: "テナントID", couponId: "クーポンID", shopId: "SC ID" }
      Common.analyticsLogEvent('use_coupon', this.couponDetail.tenantId ? {
        tenantId: this.couponDetail.tenantId,
        couponId: id,
        shopId: this.SHOP_ID,
      } : {
        couponId: id,
        shopId: this.SHOP_ID,
      });

      this.showModal = isShow;
    },
    listFiltering(e, provider) {
      $('.swiper-slide .img').removeClass('active');
      $(e.target).parent().addClass('active');
      this.couponsListTemp = this.couponsAll;
      if (provider) {
        this.couponsListTemp = this.couponsListTemp.filter(coupon => coupon.provider ? coupon.provider.id ==  provider.id : false);
      }
      this.couponsList = this.couponsListTemp.slice(0, this.couponSize);
      this.currentProvider = provider;

      this.isCouponCategory = false;
      this.selectedCategoryName = "全て";
      this.categoryListFiltering();
    },
    listFilteringByCategory(categoryId) {
      this.couponsListTemp = this.couponsAll;
      if (this.currentProvider) {
        this.couponsListTemp = this.couponsListTemp.filter(coupon => coupon.provider ? coupon.provider.id ==  this.currentProvider.id : false);
      }
      if (categoryId) {
        this.couponsListTemp = this.couponsListTemp.filter(coupon => coupon.categoryId ? coupon.categoryId ==  categoryId : false);
      }
      this.couponsList = this.couponsListTemp.slice(0, this.couponSize);

    },
    categoryListFiltering() {
      let categoryIds = [];
      this.couponsListTemp.map(coupon => {
        const categoryId = coupon.categoryId;
        if (categoryId) {
          if (!categoryIds.includes(categoryId)) {
            categoryIds.push(categoryId);
          }
        }
      });
      //console.log('categoryIds',categoryIds);
      this.couponCategorysList = this.couponCategorysListTemp;
      this.couponCategorysList = this.couponCategorysList.filter(couponCategory => {
        console.log("couponCategory",couponCategory)
        return categoryIds.includes(couponCategory.id);
      });
    },
    async addCoupon () {
      //console.log('addCoupon');
      const start = this.couponsList.length;
      //console.log('start',start);
      //console.log('this.couponsListTemp.length',this.couponsListTemp.length);
      if (start < this.couponsListTemp.length) {
          this.couponsList = this.couponsList.concat(this.couponsListTemp.slice(start, start+this.couponSize));
      }
    },
    closeCouponModal() {
      this.showModal = false
      this.couponDetail = {}
      this.showCouponDialog=true;
      this.showContinueDialog= false;
      this.showUsedCouponDialog= false;
      this.useCoupnData=null;
      this.isUseCouponEnabled=false
      this.showUsageHistoryDialog=false
      this.loading= false;
      this.cancelCode=null
    },
    closeMogiriCouponModal() {
      this.showContinueDialog = false
    },

    showUseMogiriCoupon() {
      if (
        !this.couponDetail.unlimited && 
        !this.isDateNow(this.couponDetail.availableFrom,this.couponDetail.availableTo)
      ) return false

      this.showCouponDialog = false;
      this.showContinueDialog = true;
    },
    
    cancelUseCoupon() {
      this.closeCouponModal()
    },
    
    showCancellationCoupon() {
      this.showContinueDialog = false;
      this.showUsedCouponDialog = true;
    },
    
    cancelCancellationCoupon() {
      this.showUsedCouponDialog = false;
      this.showContinueDialog = true;
    },
    //使用済みにする
    async applyUsedCoupon() {
      if (this.isUseCouponEnabled) return false;
      if (this.isUseCouponProcessing) return false;

      if (this.couponDetail.tenantSelectedType) {
        if (!this.selectTenantId) {
          this.selectTenantErrMsg = "選択されていません。"
          return false;
        }
      }

      this.isUseCouponProcessing = true;
      const userId = this.$store.state.userId;
      this.loading = true;
      const callable = firebase.functions('asia-northeast1').httpsCallable('useCoupon');
      const request = {
        "userId": userId,
        "couponId": this.couponDetail.id
      };
      if (this.user && this.user.lineFootPrint) {
        request.lineFootPrint = this.user.lineFootPrint;
      }
      if (this.couponDetail.lotteryId) {
        request.lotteryId = this.couponDetail.lotteryId;
        const lottery = await getLottery(this.couponDetail.lotteryId);
        if (lottery.codeType == 2) {
          // codeType=2（複数コード指定）、かつ同一抽選コードによる抽選を利用不可の場合
          request.lotteryEntryId = this.couponDetail.lotteryEntryId;
        }
      }
      if (this.couponDetail.qreResultId) {
        request.qreResultId = this.couponDetail.qreResultId;
      }
      if (this.couponDetail.tenantSelectedType) {
        request.tenantId = this.selectTenantId;
      }
      const result = await callable(request)
        .catch(async e => {
          this.loading = false;
          this.isUseCouponProcessing = false;
          if (e?.details?.code == "coupon-exceeded-all-limit" || e?.details?.code == "coupon-exceeded-tenant-limit") {

            if (e?.details?.code == "coupon-exceeded-all-limit") {
              this.errorLimitMessage = "全体の上限数に達したため使用できません。"

            } else if (e?.details?.code == "coupon-exceeded-tenant-limit") {
              this.errorLimitMessage = "選択された店舗での上限数に達したため使用できません。"
            }

            this.errorModal = true;
          } else {
            await this.alert("エラーが発生しました。" + (e?.message||""), true);
          }
          throw e;
        });
      if (result.data.status == 'SUCCEED') {
        // Firebase analytics 
        // { tenantId: "テナントID", couponId: "クーポンID", shopId: "SC ID" }
        Common.analyticsLogEvent('mogiri_coupon', this.couponDetail.tenantId ? {
          tenantId: this.couponDetail.tenantId,
          couponId: this.couponDetail.id,
          shopId: this.SHOP_ID,
        } : {
          couponId: this.couponDetail.id,
          shopId: this.SHOP_ID,
        });
        this.getLocalDataCoupons();
        this.closeCouponModal();
        await this.alert(`クーポンを使用しました。`);
        //if (!result) {}
      }
      this.isUseCouponProcessing = false;
    },
    //使用取り消しをする
    async applyCancellationCoupon() {
      if (!this.cancelCode) {
        this.alert("認証コードを入力してください");
        return false;
      }
      this.loading =true;
      const userId = this.$store.state.userId;
      const callable = firebase.functions('asia-northeast1').httpsCallable('cancelCoupon');
      const request = {
        "userId":userId,
        "couponId": this.couponDetail.id,
        "cancelCode": this.cancelCode
      };
      const result = await callable(request)
        .catch(async e => {
                this.loading =false;
          await this.alert("エラーが発生しました。" + (e?.message||""), true);
          throw e;
        });
      if (result.data.status == 'SUCCEED') {
        // Firebase analytics 
        // { tenantId: "テナントID", couponId: "クーポンID", shopId: "SC ID" }
        Common.analyticsLogEvent('cancel_coupon', this.couponDetail.tenantId ? {
          tenantId: this.couponDetail.tenantId,
          couponId: this.couponDetail.id,
          shopId: this.SHOP_ID,
        } : {
          couponId: this.couponDetail.id,
          shopId: this.SHOP_ID,
        });
        this.closeCouponModal();
        await this.alert(`クーポンの使用取消を行いました。`);
      }
    },
    toggleSelectCategoryList() {
      this.isCouponCategory = !this.isCouponCategory
    },
    selectCategory(categoryId,title) {
      this.listFilteringByCategory(categoryId);
      this.isCouponCategory = false;

      if (categoryId) {
      this.selectedCategoryName = title;
      } else {
      this.selectedCategoryName = "全て";
      }
    },
    closeErrorModal() {
      this.errorModal = false
      //ここで一覧更新する
    },
    showUsageHistory() {
      this.showContinueDialog = false
      this.showUsageHistoryDialog = true
    },
    changeSelectCategoryType() {
      this.selectTenantId = "";
      this.selectTenantErrMsg = "";
      this.selectTenantList = {};
      const _selectTenantList = {}
      for (const tenantSelectedData of this.couponDetail.tenantSelectedDatas) {
        const provider = this.providersAll.find(item => item.id == tenantSelectedData.tenantId);
        if (provider) {
        if (this.selectCategoryType == "0" || provider.shopCategoryType == this.selectCategoryType) {
            _selectTenantList[provider.id] = provider.shopName;
          }
        }
      }
      const sortTenantList = Object.entries(_selectTenantList).sort((a, b) => a[1].localeCompare(b[1],"ja"));  

      for (const sortTenant of sortTenantList) {
        this.selectTenantList[sortTenant[0]] = sortTenant[1] 
      }
    },
    async overLine(mogiri,maximumNumber,totalUseCount,id,lotteryId,lotteryEntryId,qreResultId) {
      if (mogiri) {
      if (maximumNumber) {
        // 上限到達判定
        // 全店対象、かつ上限数設定がある場合
        if (totalUseCount >= maximumNumber) {
          // 上限を超えている場合、既に使用した人以外はアプリでグレーアウト

          let userData  = await getCouponUseHistorys(this.$store.state.userId,id,lotteryId,lotteryEntryId,qreResultId);

          if (userData.length <= 0) {
            return true;
          }
        }
      }
      }
      return false;
    },
    isDateNow(availableFrom, availableTo) {
      if (!availableFrom)  return true
      const isDateNow = new Date().valueOf();

      //開始日過ぎてる
      if (availableFrom < isDateNow) {
        if (!availableTo)  return true
        if (isDateNow < availableTo) return true
      }
      return false
    },
    userCountRemaining(usablenumber,  useCount) {
      const total = usablenumber - useCount;
      return total > 0 ?  total : 0
    }
  }
})
</script>
